import React, { useState, useRef } from "react";
import Autosuggest from "react-autosuggest";
import "./style.css";
import "@dtpk-cc/components/dist/components/AddressInput/AddressInput.css";
import "@dtpk-cc/components/dist/components/Input/Input.css";
export default function Autocomplete(props) {
  const {
    zip,
    onZipChange,
    city,
    errors,
    onCityChange,
    onDistrictChange,
    street,
    onStreetChange,
    onHouseNumberChange,
    onHouseNumberAdditionChange,
  } = props;

  const [zipCitySuggestions, setZipCitySuggestions] = useState([]);
  const [zipCityValue, setZipCityValue] = useState("");

  const [streetSuggestions, setStreetSuggestions] = useState([]);
  const [streetValue, setStreetValue] = useState("");

  const [houseNumberSuggestions, setHouseNumberSuggestions] = useState([]);
  const [houseNumberValue, setHouseNumberValue] = useState("");

  const [lastStreet, setLastStreet] = useState("");

  const zipCityInputRef = useRef(null);
  const streetInputRef = useRef(null);
  const houseNumberInputRef = useRef(null);

  const buildCitySuggestion = (city) => {
    return {
      city: city,
    };
  };

  const getZipCitySuggestions = (value) => {
    return new Promise((resolve) => {
      if (value.length < 1) {
        onZipChange("");
        onCityChange("");
        onDistrictChange("");
        return resolve([]);
      }
      if (value.length < 3) {
        onZipChange("");
        onCityChange("");
        onDistrictChange("");
        return resolve([{ error: "zu viele Treffer gefunden", value: value }]);
      }
      if (value.length < 4) {
        onZipChange("");
        onCityChange("");
        onDistrictChange("");
      }

      let fetchUrl;
      if (isNaN(value)) {
        fetchUrl = `${process.env.REACT_APP_AUTOCOMPLETE_URL}/cities?city=${value}`;
      } else {
        fetchUrl = `${process.env.REACT_APP_AUTOCOMPLETE_URL}/zipcodes?zipcode=${value}`;
      }

      fetch(fetchUrl)
        .then((response) => response.json())
        .then((data) => {
          if (data.length > 0) {
            const cities = Array.from(
              new Set(data.filter((i) => !i.district).map((i) => i.city))
            )
              .sort()
              .map(buildCitySuggestion);
            setZipCitySuggestions(cities.concat(data));
          } else {
            resolve([{ error: "keine Treffer gefunden", value: value }]);
          }
        });
    });
  };

  const getZipCitySuggestionValue = (suggestion) => {
    if (suggestion.error) return suggestion.value;
    return suggestion.district
      ? `${suggestion.zipcode}, ${suggestion.city}, ${suggestion.district}`
      : suggestion.zipcode
      ? `${suggestion.zipcode}, ${suggestion.city}`
      : suggestion.city;
  };

  const renderZipCitySuggestion = (suggestion) => (
    <span>
      {suggestion.error
        ? suggestion.error
        : suggestion.district
        ? `${suggestion.zipcode}, ${suggestion.city}, ${suggestion.district}`
        : suggestion.zipcode
        ? `${suggestion.zipcode}, ${suggestion.city}`
        : suggestion.city}
    </span>
  );
  const onZipCitySuggestionsFetchRequested = ({ value }) => {
    getZipCitySuggestions(value);
  };
  const onZipCitySuggestionsClearRequested = () => {
    setZipCitySuggestions([]);
  };
  const onZipCityChange = (event, { newValue }) => {
    setZipCityValue(newValue);
  };
  const onZipCitySelected = (e, { suggestion }) => {
    onZipChange(suggestion.zipcode);
    onCityChange(suggestion.city);
    onDistrictChange(suggestion.district ? suggestion.district : "");
    streetInputRef.current.input.focus();
  };
  const onZipCityBlur = (e, { highlightedSuggestion }) => {
    if (highlightedSuggestion && !highlightedSuggestion.error) {
      onZipChange(highlightedSuggestion.zipcode);
      onCityChange(highlightedSuggestion.city);
      onDistrictChange(
        highlightedSuggestion.district ? highlightedSuggestion.district : ""
      );
      streetInputRef.current.input.focus();
    }
  };

  // Street Suggestions
  const getStreetSuggestions = (value) => {
    const streetUrl = `${
      process.env.REACT_APP_AUTOCOMPLETE_URL
    }/streets?street=${value}&zipcode=${zip}&city=${encodeURI(city)}`;
    return new Promise((resolve) => {
      if (value.length < 1) {
        return setStreetSuggestions([]);
      }
      if (!zip && !city) {
        return setStreetSuggestions([
          { error: "zu viele Treffer gefunden", value: value },
        ]);
      }
      onStreetChange(value);
      fetch(streetUrl)
        .then((response) => response.json())
        .then((data) => {
          if (data.length > 0) {
            setStreetSuggestions(data);
            setLastStreet(data[0]);
          } else {
            setStreetSuggestions(
              lastStreet
                ? [lastStreet]
                : [{ error: "keine Treffer gefunden", value: value }]
            );
            // resolve([{ error: "keine Treffer gefunden", input: input }]);
            // resolve(this.lastStreet ? [this.lastStreet] : [{ error: "keine Treffer gefunden", input: input }]);
          }
        });
    });
  };
  const getStreetSuggestionValue = (suggestion) => {
    return suggestion.error ? suggestion.value : suggestion.street;
  };
  const renderStreetSuggestion = (suggestion) => (
    <span>
      {zip
        ? suggestion.error
          ? suggestion.error
          : suggestion.district
          ? `${suggestion.street}, ${suggestion.city}, ${suggestion.district}`
          : `${suggestion.street}, ${suggestion.city}`
        : suggestion.error
        ? suggestion.error
        : suggestion.district
        ? `${suggestion.street}, ${suggestion.zipcode}, ${suggestion.city}, ${suggestion.district}`
        : `${suggestion.street}, ${suggestion.zipcode}, ${suggestion.city}`}
    </span>
  );
  const onStreetSuggestionsFetchRequested = ({ value }) => {
    getStreetSuggestions(value);
  };
  const onStreetSuggestionsClearRequested = () => {
    setStreetSuggestions([]);
  };
  const onStreetInputChange = (event, { newValue }) => {
    setStreetValue(newValue);
  };
  const onStreetSelected = (e, { suggestion }) => {
    onZipChange(suggestion.zipcode);
    onCityChange(suggestion.city);
    onDistrictChange(suggestion.district ? suggestion.district : "");
    onStreetChange(suggestion.street);
    setZipCityValue(
      `${suggestion.zipcode}, ${suggestion.city}${
        suggestion.district ? ", " + suggestion.district : ""
      }`
    );
    houseNumberInputRef.current.input.focus();
  };
  const onStreetBlur = (e, { highlightedSuggestion }) => {
    if (highlightedSuggestion && !highlightedSuggestion.error) {
      onZipChange(highlightedSuggestion.zipcode);
      onCityChange(highlightedSuggestion.city);
      onDistrictChange(
        highlightedSuggestion.district ? highlightedSuggestion.district : ""
      );
      onStreetChange(highlightedSuggestion.street);
      setZipCityValue(
        `${highlightedSuggestion.zipcode}, ${highlightedSuggestion.city}${
          highlightedSuggestion.district
            ? ", " + highlightedSuggestion.district
            : ""
        }`
      );
      setStreetValue(highlightedSuggestion.street);
      houseNumberInputRef.current.input.focus();
    }
  };

  // HouseNumber Suggestions
  const getHouseNumberSuggestions = (value) => {
    let hnr = value.match(/(\d*)/)[0];
    const houseNrUrl = `${
      process.env.REACT_APP_AUTOCOMPLETE_URL
    }/housenumbers?housenumber=${hnr}&zipcode=${zip}&city=${encodeURI(
      city
    )}&street=${encodeURI(street)}`;
    return new Promise((resolve) => {
      if (hnr.length < 1) {
        return resolve([]);
      }
      if ((!zip && !city) || !street) {
        return resolve([{ error: "zu viele Treffer gefunden", value: hnr }]);
      }
      onHouseNumberChange(hnr);
      fetch(houseNrUrl)
        .then((response) => response.json())
        .then((data) => {
          if (data.length > 0) {
            // eslint-disable-next-line
            data.sort(function (compare1, compare2) {
              if (compare1.housenumber > compare2.housenumber) return -1;
              if (compare1.housenumber < compare2.housenumber) return 1;
              if (
                compare1.housenumberadditional > compare2.housenumberadditional
              )
                return -1;
              if (
                compare1.housenumberadditional < compare2.housenumberadditional
              )
                return 1;
            });
            setHouseNumberSuggestions(data.reverse());
          } else {
            resolve([{ error: "keine Treffer gefunden", value: hnr }]);
          }
        });
    });
  };
  const getHouseNumberSuggestionValue = (suggestion) => {
    return suggestion.error
      ? suggestion.value
      : suggestion.housenumberadditional
      ? `${suggestion.housenumber} ${suggestion.housenumberadditional}`
      : suggestion.housenumber;
  };
  const renderHouseNumberSuggestion = (suggestion) => (
    <span>
      {suggestion.error
        ? suggestion.value
        : suggestion.housenumberadditional
        ? `${suggestion.housenumber} ${suggestion.housenumberadditional}`
        : suggestion.housenumber}
    </span>
  );
  const onHouseNumberSuggestionsFetchRequested = ({ value }) => {
    getHouseNumberSuggestions(value);
  };
  const onHouseNumberSuggestionsClearRequested = () => {
    setHouseNumberSuggestions([]);
  };
  const onHouseNumberInputChange = (event, { newValue }) => {
    setHouseNumberValue(newValue);
  };
  const onHouseNumberSelected = (e, { suggestion }) => {
    onHouseNumberChange(suggestion.housenumber);
    onHouseNumberAdditionChange(
      suggestion.housenumberadditional ? suggestion.housenumberadditional : ""
    );
  };
  const onHouseNumberBlur = (e, { highlightedSuggestion }) => {
    if (highlightedSuggestion && !highlightedSuggestion.error) {
      onHouseNumberChange(highlightedSuggestion.housenumber);
      onHouseNumberAdditionChange(
        highlightedSuggestion.housenumberadditional
          ? highlightedSuggestion.housenumberadditional
          : ""
      );
    }
  };

  const zipCityProps = {
    value: zipCityValue,
    label: "PLZ oder Wohnort*",
    id: "zipCity",
    className: `Input__input___5vxBY ${zipCityValue ? "is-active" : ""} ${
      errors.some((el) => el.field === "plz") ||
      errors.some((el) => el.field === "ort")
        ? "is-invalid"
        : ""
    }`,
    onChange: onZipCityChange,
    onBlur: onZipCityBlur,
    "data-errormsg": "Die PLZ oder der Wohnort sind ungültig.",
    "aria-invalid":
      errors.some((el) => el.field === "plz") ||
      errors.some((el) => el.field === "ort"),
    autoComplete:
      navigator &&
      navigator.userAgent &&
      navigator.userAgent.search("Chrome") >= 0
        ? "new-password"
        : "off",
  };
  const streetProps = {
    value: streetValue,
    label: "Straße*",
    id: "street",
    className: `Input__input___5vxBY ${streetValue ? "is-active" : ""} ${
      errors.some((el) => el.field === "strasse") ? "is-invalid" : ""
    }`,
    onChange: onStreetInputChange,
    onBlur: onStreetBlur,
    "data-errormsg": "Die Straße ist ungültig.",
    "aria-invalid": errors.some((el) => el.field === "strasse"),
    autoComplete:
      navigator &&
      navigator.userAgent &&
      navigator.userAgent.search("Chrome") >= 0
        ? "new-password"
        : "off",
  };
  const houseNumberProps = {
    value: houseNumberValue,
    label: "Hausnr.*",
    id: "houseNumber",
    className: `Input__input___5vxBY ${houseNumberValue ? "is-active" : ""} ${
      errors.some((el) => el.field === "hausnummer") ? "is-invalid" : ""
    }`,
    onChange: onHouseNumberInputChange,
    onBlur: onHouseNumberBlur,
    "data-errormsg": "Die Hausnummer ist ungültig.",
    "aria-invalid": errors.some((el) => el.field === "hausnummer"),
    autoComplete:
      navigator &&
      navigator.userAgent &&
      navigator.userAgent.search("Chrome") >= 0
        ? "new-password"
        : "off",
  };
  const renderInputComponent = (inputProps) => (
    <div className="Input__wrapper___jV2Jt">
      <input {...inputProps} />
      <label htmlFor={inputProps.id} className="Input__label___1zkjm">
        {inputProps.label}
      </label>
      {inputProps["aria-invalid"] && (
        <p className="Input__message___3l57-">{inputProps["data-errormsg"]}</p>
      )}
    </div>
  );

  return (
    <div className="AddressInput__row">
      <div className="AddressInput__col zipCityInput">
        <Autosuggest
          suggestions={zipCitySuggestions}
          onSuggestionsFetchRequested={onZipCitySuggestionsFetchRequested}
          onSuggestionsClearRequested={onZipCitySuggestionsClearRequested}
          getSuggestionValue={getZipCitySuggestionValue}
          renderSuggestion={renderZipCitySuggestion}
          onSuggestionSelected={onZipCitySelected}
          inputProps={zipCityProps}
          focusInputOnSuggestionClick={false}
          highlightFirstSuggestion={true}
          renderInputComponent={renderInputComponent}
          ref={zipCityInputRef}
          id="zipCity"
        />
      </div>
      <div className="AddressInput__col streetInput">
        <Autosuggest
          suggestions={streetSuggestions}
          onSuggestionsFetchRequested={onStreetSuggestionsFetchRequested}
          onSuggestionsClearRequested={onStreetSuggestionsClearRequested}
          getSuggestionValue={getStreetSuggestionValue}
          renderSuggestion={renderStreetSuggestion}
          onSuggestionSelected={onStreetSelected}
          inputProps={streetProps}
          focusInputOnSuggestionClick={false}
          highlightFirstSuggestion={true}
          renderInputComponent={renderInputComponent}
          ref={streetInputRef}
          id="street"
        />
      </div>
      <div className="AddressInput__col houseNumberInput">
        <Autosuggest
          suggestions={houseNumberSuggestions}
          onSuggestionsFetchRequested={onHouseNumberSuggestionsFetchRequested}
          onSuggestionsClearRequested={onHouseNumberSuggestionsClearRequested}
          getSuggestionValue={getHouseNumberSuggestionValue}
          renderSuggestion={renderHouseNumberSuggestion}
          onSuggestionSelected={onHouseNumberSelected}
          inputProps={houseNumberProps}
          focusInputOnSuggestionClick={false}
          highlightFirstSuggestion={true}
          renderInputComponent={renderInputComponent}
          ref={houseNumberInputRef}
          id="houseNumber"
        />
      </div>
    </div>
  );
}
